import { useEffect, useRef } from 'react';
import { Col, Row } from 'antd';
import usePrestationsEditor from '../../../../hooks/usePrestationsEditor';
import PrestationsSelector from './PrestationsSelector';
import ServiceDetailPanel from './ServiceDetailPanel';

const PrestationsEditor = ({
  initialPrestations,
  branchOfficeId,
  companyReportType,
  companyId,
  outsourcingId,
  thirdPartyId,
  evaluationType,
  patientData,
  addAttachedServices,
  observacionesProtocolo,
  observacionesOtras,
  onPrestationsChange,
}) => {
  const hasSeeded = useRef(false);
  const {
    selectedPrestations,
    activePrestationKey,
    activePrestation,
    servicesList,
    availableExams,
    loading,
    seedPrestations,
    fetchServices,
    fetchExams,
    onAddPrestation,
    onRemovePrestation,
    onSelectActive,
    onReportTypeChange,
    onAddAdditional,
    onRemoveExam,
    onToggleKeyword,
    getLegendClass,
    setServicesList,
  } = usePrestationsEditor({
    branchOfficeId,
    companyReportType,
    companyId,
    outsourcingId,
    thirdPartyId,
    evaluationType,
    patientData,
    addAttachedServices,
  });

  useEffect(() => {
    if (initialPrestations?.length && !hasSeeded.current) {
      hasSeeded.current = true;
      seedPrestations(initialPrestations);
    }
  }, [initialPrestations, seedPrestations]);

  useEffect(() => {
    if (onPrestationsChange) {
      onPrestationsChange(selectedPrestations);
    }
  }, [onPrestationsChange, selectedPrestations]);

  const handleAddPrestation = (option) => {
    onAddPrestation(option);
    setServicesList([]);
  };

  return (
    <Row gutter={30}>
      <Col lg={8} xs={24}>
        <PrestationsSelector
          selectedPrestations={selectedPrestations}
          activePrestationKey={activePrestationKey}
          activePrestation={activePrestation}
          onSelectActive={onSelectActive}
          onAddPrestation={handleAddPrestation}
          onRemovePrestation={onRemovePrestation}
          servicesList={servicesList}
          loading={loading}
          onSearch={fetchServices}
          onToggleKeyword={onToggleKeyword}
          observacionesProtocolo={observacionesProtocolo || null}
          observacionesOtras={observacionesOtras || null}
          getLegendClass={getLegendClass}
        />
      </Col>
      <Col lg={16} xs={24}>
        <ServiceDetailPanel
          prestation={activePrestation}
          availableExams={availableExams}
          loading={loading}
          onRemovePrestation={onRemovePrestation}
          onReportTypeChange={onReportTypeChange}
          onSearchAdditionals={fetchExams}
          onAddAdditional={onAddAdditional}
          onRemoveExam={onRemoveExam}
          getLegendClass={getLegendClass}
        />
      </Col>
    </Row>
  );
};

export default PrestationsEditor;
